import { vars } from "@pancakeswap/ui/css/vars.css";

export const lightColors = vars.colors;

export const darkColors = vars.colors;

export const blueColors = vars.colors;
